import React from 'react';

// 应用于一体机中自定义长列表的scroll
function OverflowContainer(props) {
  const { className, children } = props;
  return <div className={className}>{children}</div>;
}

export default OverflowContainer;
